import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import authAxios from "../../components/authAxios";

import { useNavigate } from "react-router-dom";
import NumberFormat from "react-number-format";
import { TextField } from "@mui/material";

import {Fab} from "@mui/material";
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';

import ManagementContractEdit from "./ManagementContractEdit";

import { Timeline } from "antd";

import "./Rentals.css"


const ManagementContract = ({property}) => {
    const navigate = useNavigate()
    const [isModalOpen, setIsModalOpen] = useState(false);
    
    const { data: mcEvents } = useQuery({
        queryKey: ['mcEvents'],
        queryFn: async () => {
            const response = await authAxios.get(`/rentals/management-contract-events/?property=${property.id}`);
            return response.data
        },
    });

    const { data: managementContract } = useQuery({
        queryKey: ['managementContract'],
        queryFn: async () => {
            const response = await authAxios.get(`/rentals/management-contracts/?property=${property.id}`);
            return response.data[0]
        },
    });

    return(
        <>
        {managementContract && (
            <section className="dashboard-form rentals-management-contract" style={{ display: 'flex', gap: '2rem' }}>

                <div style={{ flex: '0 0 70%' }}>
                    <form noValidate autoComplete="off" >
                        <div className="grouped-fields-light">
                            <TextField className="custom-input"
                                label="Reference"
                                variant="outlined" 
                                fullWidth
                                defaultValue = {managementContract?.reference}
                                InputProps={{ readOnly: true }}
                            />

                            {/* <TextField className="custom-input"
                                label="Name"
                                variant="outlined" 
                                fullWidth
                                defaultValue = {property.name}
                                InputProps={{ readOnly: true }}
                            /> */}

                            <TextField className="custom-input"
                                // value={managementContract?.start_date}
                                value={managementContract?.start_date || ''}
                                label="Start Date"
                                variant="outlined" 
                                fullWidth
                                // defaultValue = {managementContract?.start_date}
                                InputProps={{ readOnly: true }}
                            />
                            <TextField className="custom-input"
                                value={managementContract?.status_name || ''}
                                label="Status"
                                variant="outlined" 
                                fullWidth
                                // defaultValue = {managementContract?.fee_structure}
                                InputProps={{ readOnly: true }}
                            />

                            {managementContract?.fee_structure === '020' ? (
                                <TextField className="custom-input"
                                    value={managementContract?.fee_percentage || ''}
                                    label="Management Fee"
                                    variant="outlined" 
                                    fullWidth
                                    // defaultValue = {managementContract?.fee_percentage}
                                    InputProps={{ readOnly: true }}
                                />
                            )   
                            : 
                            (
                                <TextField className="custom-input"
                                    value={managementContract?.fee_amount || ''}
                                    label="Management Fee"
                                    variant="outlined" 
                                    fullWidth
                                // defaultValue = {managementContract?.fee_percentage}
                                InputProps={{ readOnly: true }}
                            />
                            )}
                        </div>

                        <div className="grouped-fields-light">
                            <TextField className="custom-input"
                                label="Landlord"
                                variant="outlined" 
                                fullWidth
                                // defaultValue = {property.landlord}
                                defaultValue = {property.owner}
                                InputProps={{ readOnly: true }}
                            />

                        </div>
                    </form>
                </div>

                <div 
                    // className="grouped-fields-light"
                    style={{ 
                            flex: '0 0 27%', 
                            // backgroundColor: '#f5f5f5', 
                            padding: '1rem',
                            borderRadius: '8px',    
                            height: 'fit-content'
                    }}
                >
                    <Timeline>
                        {mcEvents && mcEvents.map(mcEvent => (
                            // <Timeline.Item color='green' key={workflow.id}>{workflow.status_name}</Timeline.Item>
                            <Timeline.Item key={mcEvent.id}>{mcEvent.type_name} {mcEvent.date}</Timeline.Item>

                        ))}
                    </Timeline>

                </div>

                <ManagementContractEdit 
                    managementContract={managementContract}
                    isModalOpen={isModalOpen}
                    setIsModalOpen={setIsModalOpen}
                />

            </section>
        )}

        {/* <Fab 
            className="fab" 
            color="primary" 
            aria-label="add" 
            onClick={()=>{
                setIsModalOpen(true) 
            }}
        >
            <EditIcon />
        </Fab> */}
        </>

    )
}

export default ManagementContract;